var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddConditionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5 17L22 19.5L19.5 22",
    stroke: "#1B224C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4 6C5.10455 6 6 5.10455 6 4C6 2.89543 5.10455 2 4 2C2.89543 2 2 2.89543 2 4C2 5.10455 2.89543 6 4 6Z",
    stroke: "#1B224C",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6 4H10C11.1045 4 12 4.89543 12 6V17.5C12 18.6045 12.8954 19.5 14 19.5H22",
    stroke: "#1B224C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddConditionIcon);
export default __webpack_public_path__ + "static/media/addConditionIcon.e6abe3a618335f473549362b96192d3e.svg";
export { ForwardRef as ReactComponent };